import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostListener,
	Input,
	Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView } from '@core/interfaces';
import { IconComponent } from '../icon/icon.component';
import {
	ImageViewerStatusEnum,
	ImageViewerCloseRoleEnum,
	ImageViewerCloseRoleEnumValues,
} from './enums';
import { ImageViewerModalPresenter } from './image-viewer-modal.presenter';
import { IImageViewerComponent, IImageViewerPresenter } from './interfaces';

@Component({
	selector: 'app-image-viewer-modal',
	templateUrl: './image-viewer-modal.component.html',
	styleUrls: ['./image-viewer-modal.component.scss'],
	imports: [CommonModule, IconComponent],
	providers: [ImageViewerModalPresenter],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class ImageViewerModalComponent
	extends IAbstractView<IImageViewerPresenter>
	implements IImageViewerComponent
{
	readonly StatusEnum = ImageViewerStatusEnum;
	readonly CloseRoleEnum = ImageViewerCloseRoleEnum;

	@Input() imageUrl: string = '';
	@Input() altText: string = 'Imagen del producto';

	@Output() modalClose = new EventEmitter<ImageViewerCloseRoleEnumValues>();

	constructor(presenter: ImageViewerModalPresenter) {
		super(presenter);
	}

	@HostListener('document:keydown.escape')
	onEscapeKey(): void {
		this.closeModal(this.CloseRoleEnum.KEYBOARD);
	}

	closeModal(role: ImageViewerCloseRoleEnumValues = this.CloseRoleEnum.BUTTON): void {
		this.presenter.closeModal(role);
	}

	onImgError(event: Event): void {
		this.presenter.onImgError(event);
	}

	onImageLoad(): void {
		this.presenter.onImageLoad();
	}

	onBackdropClick(event: MouseEvent): void {
		this.presenter.onBackdropClick(event);
	}

	onContentClick(event: MouseEvent): void {
		event.stopPropagation();
	}
}
